import { UerChapter, UerClassifier } from 'constantsProject';
import type { ChapterEnum, UerClassifierEnum } from 'gql/graphql';

import type { SelectOption } from './types';

export enum MassUploadType {
    EstimateBasisZip = 'estimateBasisZip',
    EstimateBasisFiles = 'estimateBasisFiles',
    WorkScopes = 'workScopes',
}

export const massUploadItems = [
    {
        label: 'Загрузить ZIP-файл смет-оснований',
        value: MassUploadType.EstimateBasisZip,
    },
    {
        label: 'Загрузить файлы смет-оснований',
        value: MassUploadType.EstimateBasisFiles,
    },
    {
        label: 'Загрузить виды работ для расценок',
        value: MassUploadType.WorkScopes,
    },
];

type MassUploadModalConfig = {
    title: string;
    accept: string[];
    multiple: boolean;
    withSelectors: boolean;
};

export const massUploadModalSettings: Record<MassUploadType, MassUploadModalConfig> = {
    [MassUploadType.EstimateBasisZip]: {
        title: 'Загрузка смет-оснований',
        accept: ['.zip'],
        multiple: false,
        withSelectors: true,
    },
    [MassUploadType.EstimateBasisFiles]: {
        title: 'Загрузка смет-оснований',
        accept: ['.xml'],
        multiple: true,
        withSelectors: true,
    },
    [MassUploadType.WorkScopes]: {
        title: 'Загрузка видов работ',
        accept: ['.xlsx'],
        multiple: false,
        withSelectors: false,
    },
};

export const uerClassifierOptions: SelectOption<UerClassifierEnum>[] = Object.entries(UerClassifier).map(
    ([id, label]) => ({
        id: id as UerClassifierEnum,
        label,
    }),
);

export const chapterOptions: SelectOption<ChapterEnum>[] = Object.entries(UerChapter).map(([id, number]) => ({
    id: id as ChapterEnum,
    label: `Глава ${number}`,
}));

export const massUploadDefaultValues = {
    justification: '',
    uerClassifier: null,
    chapter: null,
    files: [] as File[],
};

/**
 * ID справочника УЕР, для которых загрузка видов работ заблокирована (так как айди на бэкенде всегда будут такими, то привязываемся к ним)
 */
export const CatalogUERIdWithDisabledWorkScopes = [-2];
